export default __webpack_public_path__ + "media/images/theme/m_logo_light-116ca084e4b4d2f45f6cbaa90a354faa.png";